import { useState } from "react";

import Cierre from "../formularios/Cierre";
import classes from "./CierreModal.module.css";
import cancel from "../../img/icono_cancel.png";

function ModalCierre(props) {
  const [modal_cierre_visible, setModal_cierre_visible] = useState(
    false
  );

  function closeModal() {
    props.setShowModalCierre(false);
  }
  
  function funcionesCierre(event) {
    event.stopPropagation();
    setModal_cierre_visible(true);

  }

  return (
    <div
      className={classes.modalContainer}
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <div
        className={classes.modal}
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        <div
          className={classes.closeModal}
          onClick={funcionesCierre}
        >
          <img className={classes.closeModal} src={cancel} alt="" />
        </div>
        <div id={"contenido_modal_cierre"}>
          <Cierre
            closeModal={closeModal}
            caso={props.caso}
            key={props.caso ? props.caso.ruc : Date.now()}
            modal_cierre_visible= {modal_cierre_visible}
            setModal_cierre_visible = {setModal_cierre_visible}
          ></Cierre>
        </div>
      </div>
    </div>
  );
}

export default ModalCierre;
